import { render, staticRenderFns } from "./ContentComponent.vue?vue&type=template&id=7a451f1a&scoped=true&"
import script from "./ContentComponent.vue?vue&type=script&lang=js&"
export * from "./ContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContentComponent.vue?vue&type=style&index=0&id=7a451f1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a451f1a",
  null
  
)

export default component.exports